import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import InvitationList from '../components/subscriptions/InvitationList';
import { withNavigation } from '../actions/navigation';

import {
  doInviteUsers,
  fetchSubscriptionInvitations,
  fetchSubscription,
} from '../actions/subscriptions';

import {
  deleteInvitation
} from '../actions/invitations';

/**
 * Subscription invitations container
 */

const mapStateToProps = ({ subscriptionsById, invitationsById }, { subscription }) => {
  const pagination = subscriptionsById[subscription.id].invitations;

  const disableInvitations = pagination 
    ? (pagination.totalCount + subscription.usersCount >= subscription.licencesCount)
    : false;

  return {
    pagination,
    invitationsById,
    disableInvitations
  };
}

const mapDispatchToProps = (dispatch, { subscription }) => {
  const handleLoadPage = (limit, token) => {
    return dispatch(fetchSubscriptionInvitations(subscription.id, limit, token))
  }
  return {
    handleLoadPage,

    handleInviteUsers: (emails) => 
      dispatch(doInviteUsers(subscription.id, emails))
        .then(() => dispatch(fetchSubscription(subscription.id))),  // needed to retrieve a fresh subscription.warning

    handleCancelInvitation: (invitation) => 
      dispatch(deleteInvitation(invitation.id, invitation.token))
        .then(() => dispatch(fetchSubscription(subscription.id))),  // needed to retrieve a fresh subscription.warning
  }
}

const SubscriptionInvitations = compose(
  withNavigation,
  connect(mapStateToProps, mapDispatchToProps)
)(InvitationList);

SubscriptionInvitations.propTypes = {
  subscription: PropTypes.object.isRequired
}

export default SubscriptionInvitations;


// WEBPACK FOOTER //
// ./src/containers/SubscriptionInvitations.js